
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexq7v_jvKpDC01DeIPHliQgN3_45nCwh8L3Lzxh8KSfMkxUMeta } from "/var/www/web/pages/index.vue?macro=true";
import { default as indexC_45qGQ7v9Cxc6eeriHpBQBq35p0GAI5Tn5bSTUj8FSssMeta } from "/var/www/web/pages/area-profesional/index.vue?macro=true";
import { default as indexY9LS6CqNRy40xWGqMwdd276XrY7fMw4sDtJU53gjin0Meta } from "/var/www/web/pages/aviso-legal/index.vue?macro=true";
import { default as indexxngf6MFON98H6u74RQDQVHYO_456jzjJMo6Ve9EPjkAfIMeta } from "/var/www/web/pages/contacto/index.vue?macro=true";
import { default as indexLbEHmP7zyyFxni21BpuGQC0r_R5HTi_45kue7kJ2KGKxgMeta } from "/var/www/web/pages/contacto/te-podemos-ayudar/index.vue?macro=true";
import { default as index_YohhjdvZljioKdnX7JiHgXCRepPDcmK_451PCrnD_w_gMeta } from "/var/www/web/pages/contacto/trabaja-con-nosotros/index.vue?macro=true";
import { default as index2PlaxdwUGfJYF516DrU4tCvr8ELOneBA7nBOdpfQJhkMeta } from "/var/www/web/pages/descargas/index.vue?macro=true";
import { default as indexmnQF_45KUl4I9eRZpUizahmfeOqd2oJEtJk8516H8T6HQMeta } from "/var/www/web/pages/empresa/index.vue?macro=true";
import { default as index9T89KOc9IfLwP33OZ_aD8MZFmoBfTH5MKRE2yvCubAEMeta } from "/var/www/web/pages/politica-de-cookies/index.vue?macro=true";
import { default as indexB9_456nxt2ET6J4xBy6vQ7zBodA8cwDsEYU6otSlJnAxgMeta } from "/var/www/web/pages/politica-de-datos/candidatos/index.vue?macro=true";
import { default as indexdB0tZ20iHXGpMVx6kHHdkPZiF64I5ZOKI1GRxDKXT3cMeta } from "/var/www/web/pages/politica-de-datos/contactos/index.vue?macro=true";
import { default as indexmNk1bKXqZgg6QXDy_452Ji9dAeRzabzgfqMaIRH_45zMMxsMeta } from "/var/www/web/pages/politica-de-datos/empleados/index.vue?macro=true";
import { default as indexciuOFotYnxJ_wEghFF6yRKZYaMf3Zn_EjLZmiqHwXWIMeta } from "/var/www/web/pages/politica-de-datos/index.vue?macro=true";
import { default as indexJ2dYoPwWqbKgOUboy0EktWR_45ttpT8iY_45JaEEyz1gBMwMeta } from "/var/www/web/pages/politica-de-datos/libro-de-visitas/index.vue?macro=true";
import { default as indexZSVuuskZVVqihHqXW_G_HRvssGDRGsbXPCvdp_72WUQMeta } from "/var/www/web/pages/politica-de-datos/negocial/index.vue?macro=true";
import { default as indexdB9eBiLsYZHCIe34AcH_45sEc6SkSt3XRIAtGo57CKQEgMeta } from "/var/www/web/pages/politica-de-datos/videovigilancia/index.vue?macro=true";
import { default as indexvTDQ3V9zAYbzGjea1YPLhn8Kdm_xPjAnArc1KdqCNcoMeta } from "/var/www/web/pages/productos/accesorios/index.vue?macro=true";
import { default as indexz5cvCkmJLfOYpnukznnv0yH_WoR6UQwqZmFzApeY_45TkMeta } from "/var/www/web/pages/productos/contempo/index.vue?macro=true";
import { default as indexWazV8uXi5_HqR6_W2V70oa_45azr0eocoWJte_45SO3sTD0Meta } from "/var/www/web/pages/productos/index.vue?macro=true";
import { default as index62H7A1I0ZToRbouHs_Jdjf1O3KcdZG8lwY52Z5hMzNkMeta } from "/var/www/web/pages/productos/molduras/index.vue?macro=true";
import { default as indexWTGZjprkemG_45ImG_45VSLbz_45nNLzgHB6zhsXfURaLwAsMMeta } from "/var/www/web/pages/productos/nature-premium/index.vue?macro=true";
import { default as index1idywyhl43x8v2pd7zsbNK_XTyisl_siFKA1eru4zVkMeta } from "/var/www/web/pages/productos/puertas-entrada/index.vue?macro=true";
import { default as index_45KfiDh681rrRPmkFGpYgjepc3taM6b66eY2v062z20oMeta } from "/var/www/web/pages/productos/puertas-interior/index.vue?macro=true";
import { default as indexMg_45XbZXsjlA8j0a_EuCBs2aBQoFu0RHiUpAVDWwJJwEMeta } from "/var/www/web/pages/productos/puertas-tecnicas/index.vue?macro=true";
import { default as indexIqr_RpN_45jpxokZAMOQLVx2b4tPu6KVUsOAOug6oxzUUMeta } from "/var/www/web/pages/productos/style/index.vue?macro=true";
import { default as _91alias_93SxmAy6A0gMgOEB_rj0VnckpSsOaN0hmvA3_45sbetxYf8Meta } from "/var/www/web/pages/proyectos/[alias].vue?macro=true";
import { default as index1Mvd2bUb0AH1sTtHI_R1PURMwcDFadBQmUQ8cxfyhagMeta } from "/var/www/web/pages/proyectos/index.vue?macro=true";
import { default as v2japT5xKyYwaYeyya1VDna1Dd42udsN7ZA0HrjZ2PATcMeta } from "/var/www/web/pages/v2.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexq7v_jvKpDC01DeIPHliQgN3_45nCwh8L3Lzxh8KSfMkxUMeta || {},
    component: () => import("/var/www/web/pages/index.vue")
  },
  {
    name: "area-profesional___es",
    path: "/es/area-profesional",
    meta: indexC_45qGQ7v9Cxc6eeriHpBQBq35p0GAI5Tn5bSTUj8FSssMeta || {},
    component: () => import("/var/www/web/pages/area-profesional/index.vue")
  },
  {
    name: "area-profesional___en",
    path: "/en/professional-area",
    meta: indexC_45qGQ7v9Cxc6eeriHpBQBq35p0GAI5Tn5bSTUj8FSssMeta || {},
    component: () => import("/var/www/web/pages/area-profesional/index.vue")
  },
  {
    name: "aviso-legal___es",
    path: "/es/aviso-legal",
    meta: indexY9LS6CqNRy40xWGqMwdd276XrY7fMw4sDtJU53gjin0Meta || {},
    component: () => import("/var/www/web/pages/aviso-legal/index.vue")
  },
  {
    name: "aviso-legal___en",
    path: "/en/legal-notice",
    meta: indexY9LS6CqNRy40xWGqMwdd276XrY7fMw4sDtJU53gjin0Meta || {},
    component: () => import("/var/www/web/pages/aviso-legal/index.vue")
  },
  {
    name: "contacto___es",
    path: "/es/contacto",
    meta: indexxngf6MFON98H6u74RQDQVHYO_456jzjJMo6Ve9EPjkAfIMeta || {},
    component: () => import("/var/www/web/pages/contacto/index.vue")
  },
  {
    name: "contacto___en",
    path: "/en/contact",
    meta: indexxngf6MFON98H6u74RQDQVHYO_456jzjJMo6Ve9EPjkAfIMeta || {},
    component: () => import("/var/www/web/pages/contacto/index.vue")
  },
  {
    name: "contacto-te-podemos-ayudar___es",
    path: "/es/contacto/te-podemos-ayudar",
    meta: indexLbEHmP7zyyFxni21BpuGQC0r_R5HTi_45kue7kJ2KGKxgMeta || {},
    component: () => import("/var/www/web/pages/contacto/te-podemos-ayudar/index.vue")
  },
  {
    name: "contacto-te-podemos-ayudar___en",
    path: "/en/contact/can-we-help",
    meta: indexLbEHmP7zyyFxni21BpuGQC0r_R5HTi_45kue7kJ2KGKxgMeta || {},
    component: () => import("/var/www/web/pages/contacto/te-podemos-ayudar/index.vue")
  },
  {
    name: "contacto-trabaja-con-nosotros___es",
    path: "/es/contacto/trabaja-con-nosotros",
    meta: index_YohhjdvZljioKdnX7JiHgXCRepPDcmK_451PCrnD_w_gMeta || {},
    component: () => import("/var/www/web/pages/contacto/trabaja-con-nosotros/index.vue")
  },
  {
    name: "contacto-trabaja-con-nosotros___en",
    path: "/en/contact/work-with-us",
    meta: index_YohhjdvZljioKdnX7JiHgXCRepPDcmK_451PCrnD_w_gMeta || {},
    component: () => import("/var/www/web/pages/contacto/trabaja-con-nosotros/index.vue")
  },
  {
    name: "descargas___es",
    path: "/es/descargas",
    meta: index2PlaxdwUGfJYF516DrU4tCvr8ELOneBA7nBOdpfQJhkMeta || {},
    component: () => import("/var/www/web/pages/descargas/index.vue")
  },
  {
    name: "descargas___en",
    path: "/en/downloads",
    meta: index2PlaxdwUGfJYF516DrU4tCvr8ELOneBA7nBOdpfQJhkMeta || {},
    component: () => import("/var/www/web/pages/descargas/index.vue")
  },
  {
    name: "empresa___es",
    path: "/es/empresa",
    meta: indexmnQF_45KUl4I9eRZpUizahmfeOqd2oJEtJk8516H8T6HQMeta || {},
    component: () => import("/var/www/web/pages/empresa/index.vue")
  },
  {
    name: "empresa___en",
    path: "/en/company",
    meta: indexmnQF_45KUl4I9eRZpUizahmfeOqd2oJEtJk8516H8T6HQMeta || {},
    component: () => import("/var/www/web/pages/empresa/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexq7v_jvKpDC01DeIPHliQgN3_45nCwh8L3Lzxh8KSfMkxUMeta || {},
    component: () => import("/var/www/web/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexq7v_jvKpDC01DeIPHliQgN3_45nCwh8L3Lzxh8KSfMkxUMeta || {},
    component: () => import("/var/www/web/pages/index.vue")
  },
  {
    name: "politica-de-cookies___es",
    path: "/es/politica-de-cookies",
    meta: index9T89KOc9IfLwP33OZ_aD8MZFmoBfTH5MKRE2yvCubAEMeta || {},
    component: () => import("/var/www/web/pages/politica-de-cookies/index.vue")
  },
  {
    name: "politica-de-cookies___en",
    path: "/en/cookie-policy",
    meta: index9T89KOc9IfLwP33OZ_aD8MZFmoBfTH5MKRE2yvCubAEMeta || {},
    component: () => import("/var/www/web/pages/politica-de-cookies/index.vue")
  },
  {
    name: "politica-de-datos-candidatos___es",
    path: "/es/politica-de-datos/candidatos",
    meta: indexB9_456nxt2ET6J4xBy6vQ7zBodA8cwDsEYU6otSlJnAxgMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/candidatos/index.vue")
  },
  {
    name: "politica-de-datos-candidatos___en",
    path: "/en/data-policy/candidates",
    meta: indexB9_456nxt2ET6J4xBy6vQ7zBodA8cwDsEYU6otSlJnAxgMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/candidatos/index.vue")
  },
  {
    name: "politica-de-datos-contactos___es",
    path: "/es/politica-de-datos/contactos",
    meta: indexdB0tZ20iHXGpMVx6kHHdkPZiF64I5ZOKI1GRxDKXT3cMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/contactos/index.vue")
  },
  {
    name: "politica-de-datos-contactos___en",
    path: "/en/data-policy/contacts",
    meta: indexdB0tZ20iHXGpMVx6kHHdkPZiF64I5ZOKI1GRxDKXT3cMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/contactos/index.vue")
  },
  {
    name: "politica-de-datos-empleados___es",
    path: "/es/politica-de-datos/empleados",
    meta: indexmNk1bKXqZgg6QXDy_452Ji9dAeRzabzgfqMaIRH_45zMMxsMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/empleados/index.vue")
  },
  {
    name: "politica-de-datos-empleados___en",
    path: "/en/data-policy/employees",
    meta: indexmNk1bKXqZgg6QXDy_452Ji9dAeRzabzgfqMaIRH_45zMMxsMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/empleados/index.vue")
  },
  {
    name: "politica-de-datos___es",
    path: "/es/politica-de-datos",
    meta: indexciuOFotYnxJ_wEghFF6yRKZYaMf3Zn_EjLZmiqHwXWIMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/index.vue")
  },
  {
    name: "politica-de-datos___en",
    path: "/en/data-policy",
    meta: indexciuOFotYnxJ_wEghFF6yRKZYaMf3Zn_EjLZmiqHwXWIMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/index.vue")
  },
  {
    name: "politica-de-datos-libro-de-visitas___es",
    path: "/es/politica-de-datos/libro-de-visitas",
    meta: indexJ2dYoPwWqbKgOUboy0EktWR_45ttpT8iY_45JaEEyz1gBMwMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/libro-de-visitas/index.vue")
  },
  {
    name: "politica-de-datos-libro-de-visitas___en",
    path: "/en/data-policy/visitor-book",
    meta: indexJ2dYoPwWqbKgOUboy0EktWR_45ttpT8iY_45JaEEyz1gBMwMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/libro-de-visitas/index.vue")
  },
  {
    name: "politica-de-datos-negocial___es",
    path: "/es/politica-de-datos/negocial",
    meta: indexZSVuuskZVVqihHqXW_G_HRvssGDRGsbXPCvdp_72WUQMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/negocial/index.vue")
  },
  {
    name: "politica-de-datos-negocial___en",
    path: "/en/data-policy/business",
    meta: indexZSVuuskZVVqihHqXW_G_HRvssGDRGsbXPCvdp_72WUQMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/negocial/index.vue")
  },
  {
    name: "politica-de-datos-videovigilancia___es",
    path: "/es/politica-de-datos/videovigilancia",
    meta: indexdB9eBiLsYZHCIe34AcH_45sEc6SkSt3XRIAtGo57CKQEgMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/videovigilancia/index.vue")
  },
  {
    name: "politica-de-datos-videovigilancia___en",
    path: "/en/data-policy/video-surveillance",
    meta: indexdB9eBiLsYZHCIe34AcH_45sEc6SkSt3XRIAtGo57CKQEgMeta || {},
    component: () => import("/var/www/web/pages/politica-de-datos/videovigilancia/index.vue")
  },
  {
    name: "productos-accesorios___es",
    path: "/es/productos/accesorios",
    meta: indexvTDQ3V9zAYbzGjea1YPLhn8Kdm_xPjAnArc1KdqCNcoMeta || {},
    component: () => import("/var/www/web/pages/productos/accesorios/index.vue")
  },
  {
    name: "productos-accesorios___en",
    path: "/en/products/accessories",
    meta: indexvTDQ3V9zAYbzGjea1YPLhn8Kdm_xPjAnArc1KdqCNcoMeta || {},
    component: () => import("/var/www/web/pages/productos/accesorios/index.vue")
  },
  {
    name: "productos-contempo___es",
    path: "/es/productos/contempo",
    meta: indexz5cvCkmJLfOYpnukznnv0yH_WoR6UQwqZmFzApeY_45TkMeta || {},
    component: () => import("/var/www/web/pages/productos/contempo/index.vue")
  },
  {
    name: "productos-contempo___en",
    path: "/en/products/contempo",
    meta: indexz5cvCkmJLfOYpnukznnv0yH_WoR6UQwqZmFzApeY_45TkMeta || {},
    component: () => import("/var/www/web/pages/productos/contempo/index.vue")
  },
  {
    name: "productos___es",
    path: "/es/productos",
    meta: indexWazV8uXi5_HqR6_W2V70oa_45azr0eocoWJte_45SO3sTD0Meta || {},
    component: () => import("/var/www/web/pages/productos/index.vue")
  },
  {
    name: "productos___en",
    path: "/en/products",
    meta: indexWazV8uXi5_HqR6_W2V70oa_45azr0eocoWJte_45SO3sTD0Meta || {},
    component: () => import("/var/www/web/pages/productos/index.vue")
  },
  {
    name: "productos-molduras___es",
    path: "/es/productos/molduras",
    meta: index62H7A1I0ZToRbouHs_Jdjf1O3KcdZG8lwY52Z5hMzNkMeta || {},
    component: () => import("/var/www/web/pages/productos/molduras/index.vue")
  },
  {
    name: "productos-molduras___en",
    path: "/en/products/mouldings",
    meta: index62H7A1I0ZToRbouHs_Jdjf1O3KcdZG8lwY52Z5hMzNkMeta || {},
    component: () => import("/var/www/web/pages/productos/molduras/index.vue")
  },
  {
    name: "productos-nature-premium___es",
    path: "/es/productos/nature-premium",
    meta: indexWTGZjprkemG_45ImG_45VSLbz_45nNLzgHB6zhsXfURaLwAsMMeta || {},
    component: () => import("/var/www/web/pages/productos/nature-premium/index.vue")
  },
  {
    name: "productos-nature-premium___en",
    path: "/en/products/nature-premium",
    meta: indexWTGZjprkemG_45ImG_45VSLbz_45nNLzgHB6zhsXfURaLwAsMMeta || {},
    component: () => import("/var/www/web/pages/productos/nature-premium/index.vue")
  },
  {
    name: "productos-puertas-entrada___es",
    path: "/es/productos/puertas-entrada",
    meta: index1idywyhl43x8v2pd7zsbNK_XTyisl_siFKA1eru4zVkMeta || {},
    component: () => import("/var/www/web/pages/productos/puertas-entrada/index.vue")
  },
  {
    name: "productos-puertas-entrada___en",
    path: "/en/products/front-doors",
    meta: index1idywyhl43x8v2pd7zsbNK_XTyisl_siFKA1eru4zVkMeta || {},
    component: () => import("/var/www/web/pages/productos/puertas-entrada/index.vue")
  },
  {
    name: "productos-puertas-interior___es",
    path: "/es/productos/puertas-interior",
    meta: index_45KfiDh681rrRPmkFGpYgjepc3taM6b66eY2v062z20oMeta || {},
    component: () => import("/var/www/web/pages/productos/puertas-interior/index.vue")
  },
  {
    name: "productos-puertas-interior___en",
    path: "/en/products/interior-doors",
    meta: index_45KfiDh681rrRPmkFGpYgjepc3taM6b66eY2v062z20oMeta || {},
    component: () => import("/var/www/web/pages/productos/puertas-interior/index.vue")
  },
  {
    name: "productos-puertas-tecnicas___es",
    path: "/es/productos/puertas-tecnicas",
    meta: indexMg_45XbZXsjlA8j0a_EuCBs2aBQoFu0RHiUpAVDWwJJwEMeta || {},
    component: () => import("/var/www/web/pages/productos/puertas-tecnicas/index.vue")
  },
  {
    name: "productos-puertas-tecnicas___en",
    path: "/en/products/technical-doors",
    meta: indexMg_45XbZXsjlA8j0a_EuCBs2aBQoFu0RHiUpAVDWwJJwEMeta || {},
    component: () => import("/var/www/web/pages/productos/puertas-tecnicas/index.vue")
  },
  {
    name: "productos-style___es",
    path: "/es/productos/style",
    meta: indexIqr_RpN_45jpxokZAMOQLVx2b4tPu6KVUsOAOug6oxzUUMeta || {},
    component: () => import("/var/www/web/pages/productos/style/index.vue")
  },
  {
    name: "productos-style___en",
    path: "/en/products/style",
    meta: indexIqr_RpN_45jpxokZAMOQLVx2b4tPu6KVUsOAOug6oxzUUMeta || {},
    component: () => import("/var/www/web/pages/productos/style/index.vue")
  },
  {
    name: "proyectos-alias___es",
    path: "/es/proyectos/:alias()",
    meta: _91alias_93SxmAy6A0gMgOEB_rj0VnckpSsOaN0hmvA3_45sbetxYf8Meta || {},
    component: () => import("/var/www/web/pages/proyectos/[alias].vue")
  },
  {
    name: "proyectos-alias___en",
    path: "/en/projects/:alias()",
    meta: _91alias_93SxmAy6A0gMgOEB_rj0VnckpSsOaN0hmvA3_45sbetxYf8Meta || {},
    component: () => import("/var/www/web/pages/proyectos/[alias].vue")
  },
  {
    name: "proyectos___es",
    path: "/es/proyectos",
    meta: index1Mvd2bUb0AH1sTtHI_R1PURMwcDFadBQmUQ8cxfyhagMeta || {},
    component: () => import("/var/www/web/pages/proyectos/index.vue")
  },
  {
    name: "proyectos___en",
    path: "/en/projects",
    meta: index1Mvd2bUb0AH1sTtHI_R1PURMwcDFadBQmUQ8cxfyhagMeta || {},
    component: () => import("/var/www/web/pages/proyectos/index.vue")
  },
  {
    name: "v2___es",
    path: "/es/v2",
    meta: v2japT5xKyYwaYeyya1VDna1Dd42udsN7ZA0HrjZ2PATcMeta || {},
    component: () => import("/var/www/web/pages/v2.vue")
  },
  {
    name: "v2___en",
    path: "/en/v2",
    meta: v2japT5xKyYwaYeyya1VDna1Dd42udsN7ZA0HrjZ2PATcMeta || {},
    component: () => import("/var/www/web/pages/v2.vue")
  }
]